export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8003.84729803.jpg";